module.exports = __webpack_public_path__ + "static/media/close-button.18eba61e.png";